import React from 'react';

import CommonImage from '@/components/CommonImage';
import { ReactComponent as DownArrow } from '@/assets/icons/down-arrow-gray-dark-01.svg';

const TaskDetails = () => {
	return (
		<div className="body-content task-contetn bg-white">
			<div className="porject-details-container">
				<div className="common-accordion">
					<div className="accordion" id="accordionExample">
						<div className="card mb-0">
							<div className="card-header" id="headingOne">
								<h2 className="mb-0">
									<button
										className="btn btn-link btn-block d-flex justify-content-between text-left gray_dark_01 regular-14 weight-600 p-0"
										type="button"
										data-toggle="collapse"
										data-target="#collapseOne"
										aria-expanded="true"
										aria-controls="collapseOne"
									>
										<div className="d-flex align-items-center justify-content-between">
											<p className="medium-14">Project overview</p>
											<span className="blue regular-14 ml-2 weight-400 cursor-pointer">
												EDIT
											</span>
										</div>
										<div className="arrow-down">
											<img src="/icons/down-arrow-gray-dark-02.svg" alt="arrow" />
										</div>
									</button>
								</h2>
							</div>
							<div
								id="collapseOne"
								className="collapse scroll-x-label"
								aria-labelledby="headingOne"
								data-parent="#accordionExample"
							>
								<div className="card-body m-0 border-0">
									<div className="project-overview-content d-grid grid-columns-3">
										<div className="single-overview-content">
											<ul>
												<li className="regular-14 gray_dark_01 weight-500 d-flex align-items-center">
													<p className="title gray_dark_02">Project name:</p>
													<p className="value">Project name</p>
												</li>
												<li className="regular-14 gray_dark_01 weight-500 d-flex align-items-center">
													<p className="title gray_dark_02">Project type:</p>
													<p className="value">Project name</p>
												</li>
												<li className="regular-14 gray_dark_01 weight-500 d-flex align-items-center">
													<p className="title gray_dark_02">Brand:</p>
													<p className="value">Project name</p>
												</li>
												<li className="regular-14 gray_dark_01 weight-500 d-flex align-items-center">
													<p className="title gray_dark_02">Project status:</p>

													<div class="sort-button ml-0">
														<select
															name="sort"
															class="border-0 bg-transparent py-0 gray_dark_01"
														>
															<option value="Supplier Ranking">Running</option>
															<option value="Status">Status</option>
														</select>
													</div>
												</li>
												<li className="regular-14 gray_dark_01 weight-500 d-flex align-items-center">
													<p className="title gray_dark_02">Project progress:</p>
													<div className="progress-info task-progress-info mt-2 d-flex align-items-center justify-content-start">
														<div className="progress progress-square">
															<div
																className="progress-bar"
																style={{ width: '40%' }}
															></div>
														</div>
														<div className="progress-text ml-2">
															<p className="regular-14 gray_dark_01">4/10</p>
														</div>
													</div>
												</li>

												<li className="regular-14 gray_dark_01 weight-500 d-flex align-items-center">
													<p className="title gray_dark_02">Project owner:</p>
													<p className="value">Project name</p>
												</li>
												<li className="regular-14 gray_dark_01 weight-500 d-flex align-items-center">
													<p className="title gray_dark_02">Creator:</p>
													<p className="value">Project name</p>
												</li>
												<li className="regular-14 gray_dark_01 weight-500 d-flex align-items-center">
													<p className="title gray_dark_02">Project end date:</p>
													<p className="value">Project name</p>
												</li>
											</ul>
										</div>
										<div className="single-overview-content">
											<ul>
												<li className="regular-14 gray_dark_01 weight-500 d-flex align-items-center">
													<p className="title gray_dark_02">Buyer meeting date:</p>
													<p className="value">12-Apr, 2024</p>
												</li>
												<li className="regular-14 gray_dark_01 weight-500 d-flex align-items-center">
													<p className="title gray_dark_02">Season:</p>
													<p className="value">
														Oct/Dec (Autumn/Xmas, Cold Weather)
													</p>
												</li>
												<li className="regular-14 gray_dark_01 weight-500 d-flex align-items-center">
													<p className="title gray_dark_02">Style category:</p>
													<p className="value">
														Women’s Wear: 200 styles (Knit) Men’s Wear: 180 styles
														(Knit) Woven: 80 styles (Men’s & Women’s)
													</p>
												</li>
												<li className="regular-14 gray_dark_01 weight-500 d-flex align-items-center">
													<p className="title gray_dark_02">Fabric details:</p>

													<p className="value">Fabric details will be here</p>
												</li>
												<li className="regular-14 gray_dark_01 weight-500 d-flex align-items-center">
													<p className="title gray_dark_02">Notes:</p>
													<p className="value">Notes will be here</p>
												</li>
											</ul>
										</div>
										<div className="single-overview-content">
											<ul className="link-list">
												<li className="regular-14 gray_dark_01 weight-500 d-flex align-items-center">
													<button class="button text size32 px-0">
														<span class="ml-1 gray_dark_01 mr-2">Link</span>
														<CommonImage src="icons/add-round.svg" />
													</button>
												</li>
												<li className="regular-14 gray_dark_01 weight-500">
													<div className="option">
														<div className="dropdown">
															<button
																className="btn btn-default dropdown-toggle"
																type="button"
																id="menu1"
																data-toggle="dropdown"
																aria-expanded="false"
															>
																<img src="/icons/more_icon.svg" alt="" />
															</button>
															<ul
																className="dropdown-menu dropdown-menu-right shadow-lg"
																role="menu"
																aria-labelledby="menu1"
																x-placement="bottom-end"
															>
																<li
																	role="presentation"
																	className="px-4 pb-3 pt-3"
																>
																	<a
																		role="menuitem"
																		tabIndex={-1}
																		className="font-weight-normal  text-black"
																		href="/invoices/edit/10052"
																	>
																		Edit
																	</a>
																</li>
																<li role="presentation" className="px-4 pb-3">
																	<a
																		role="menuitem"
																		tabIndex={-1}
																		className="font-weight-normal  text-black"
																		href
																	>
																		Delete
																	</a>
																</li>
															</ul>
														</div>
													</div>
													<p className="title blue weight-400 text-underline cursor-pointer">
														Link name 1 is here
													</p>
												</li>
												<li className="regular-14 gray_dark_01 weight-500">
													<div className="option">
														<div className="dropdown">
															<button
																className="btn btn-default dropdown-toggle"
																type="button"
																id="menu1"
																data-toggle="dropdown"
																aria-expanded="false"
															>
																<img src="/icons/more_icon.svg" alt="" />
															</button>
															<ul
																className="dropdown-menu dropdown-menu-right shadow-lg"
																role="menu"
																aria-labelledby="menu1"
																x-placement="bottom-end"
															>
																<li
																	role="presentation"
																	className="px-4 pb-3 pt-3"
																>
																	<a
																		role="menuitem"
																		tabIndex={-1}
																		className="font-weight-normal  text-black"
																		href="/invoices/edit/10052"
																	>
																		Edit
																	</a>
																</li>
																<li role="presentation" className="px-4 pb-3">
																	<a
																		role="menuitem"
																		tabIndex={-1}
																		className="font-weight-normal  text-black"
																		href
																	>
																		Delete
																	</a>
																</li>
															</ul>
														</div>
													</div>
													<p className="title blue weight-400 text-underline cursor-pointer">
														Link name 1 is here
													</p>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* table */}
				<div className="task-table-and-kanban-container bg-white">
					<div class="navigation-tab bg-white px-0">
						<ul>
							<li className="active">table</li>
							<li>kanban</li>
						</ul>
					</div>
					<div className="table-kanban-filter-actions">
						<div className="filter-container-top filter-container-top-v2 bg-white justify-content-start px-0">
							<div className="filters d-block">
								<div className="filter-toggle">
									<img alt="filter" src="/icons/filter24.svg" />
									<img alt="filter" className="d-none" src=" /icons/filter-close.svg" />
									<span className="regular-14 gray_dark_02">Filter</span>
								</div>
							</div>
							{/*Filter Actions*/}
							<div className="column-hide-show-dropdown">
								<div className="dropdown">
									<button
										className="btn btn-default dropdown-toggle regular-14 gray_dark_02"
										type="button"
										id="menu1"
										data-toggle="dropdown"
										aria-expanded="false"
									>
										Column
									</button>
									<ul
										className="dropdown-menu  shadow-lg"
										role="menu"
										aria-labelledby="menu1"
										x-placement="bottom-end"
									>
										<li>
											<div className="d-flex align-items-center justify-content-between px-3 py-2">
												<p className="regular-14 gray_dark_01 weight-600">
													Show and hide column
												</p>
												<CommonImage
													className="cursor-pointer"
													src="/icons/close.svg"
												/>
											</div>
										</li>
										<li className="px-4 pb-3 pt-3">
											<div className="custom-chekbox gray-checkbox px-3">
												<div className="form-group mb-0">
													<input type="checkbox" id="11" name="" value="MINE" />
													<label
														className="regular-14 d-flex align-items-center"
														for="11"
													>
														<span className="pl-1">Comments</span>
													</label>
												</div>
											</div>
										</li>
										<li className="px-4 pb-3 pt-3">
											<div className="custom-chekbox gray-checkbox px-3">
												<div className="form-group mb-0">
													<input type="checkbox" id="11" name="" value="MINE" />
													<label
														className="regular-14 d-flex align-items-center"
														for="11"
													>
														<span className="pl-1">Owner</span>
													</label>
												</div>
											</div>
										</li>
										<li className="px-4 pb-3 pt-3">
											<div className="custom-chekbox gray-checkbox px-3">
												<div className="form-group mb-0">
													<input type="checkbox" id="11" name="" value="MINE" />
													<label
														className="regular-14 d-flex align-items-center"
														for="11"
													>
														<span className="pl-1">Start date</span>
													</label>
												</div>
											</div>
										</li>
										<li className="px-4 pb-3 pt-3">
											<div className="custom-chekbox gray-checkbox px-3">
												<div className="form-group mb-0">
													<input type="checkbox" id="11" name="" value="MINE" />
													<label
														className="regular-14 d-flex align-items-center"
														for="11"
													>
														<span className="pl-1">Due date</span>
													</label>
												</div>
											</div>
										</li>
										<li className="px-4 pb-3 pt-3">
											<div className="custom-chekbox gray-checkbox px-3">
												<div className="form-group mb-0">
													<input type="checkbox" id="11" name="" value="MINE" />
													<label
														className="regular-14 d-flex align-items-center"
														for="11"
													>
														<span className="pl-1">Status</span>
													</label>
												</div>
											</div>
										</li>
										<li className="px-4 pb-3 pt-3">
											<div className="custom-chekbox gray-checkbox px-3">
												<div className="form-group mb-0">
													<input type="checkbox" id="11" name="" value="MINE" />
													<label
														className="regular-14 d-flex align-items-center"
														for="11"
													>
														<span className="pl-1">Priority</span>
													</label>
												</div>
											</div>
										</li>
										<li className="px-4 pb-3 pt-3">
											<div className="custom-chekbox gray-checkbox px-3">
												<div className="form-group mb-0">
													<input type="checkbox" id="11" name="" value="MINE" />
													<label
														className="regular-14 d-flex align-items-center"
														for="11"
													>
														<span className="pl-1">Remarks</span>
													</label>
												</div>
											</div>
										</li>
										<li className="px-4 pb-3 pt-3">
											<div className="d-flex align-items-center justify-content-end px-4 pb-3 pt-3">
												<button className="button size32 outline">Cancel</button>
												<button className="button size32 ml-2">Submit</button>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="chip-container d-flex align-items-center flex-wrap px-4 pb-2">
							<div className="chips d-flex align-items-center flex-wrap">
								<div className="chip">
									<span>Aminul islam hasan</span>
									<span className="chip-close cursor-pointer">
										<img src="./icons/close.svg" alt="" width={12} height={12} />
									</span>
								</div>
								<div className="chip">
									<span>Aminul islam hasan</span>
									<span className="chip-close cursor-pointer">
										<img src="./icons/close.svg" alt="" />
									</span>
								</div>
								<div className="chip">
									<span>Aminul islam hasan</span>
									<span className="chip-close cursor-pointer">
										<img src="./icons/close.svg" alt="" />
									</span>
								</div>
								<div className="chip">
									<span>Aminul islam hasan</span>
									<span className="chip-close cursor-pointer">
										<img src="./icons/close.svg" alt="" />
									</span>
								</div>
							</div>
							<span className="clear">Clear all</span>
						</div>
					</div>
					<div className="task-table-accordion">
						<div className="common-accordion bg-white">
							<div className="accordion border-0" id="accordionExample">
								<div className="card mb-0">
									<div className="card-header" id="headingOne">
										<h2 className="mb-0">
											<button
												className="btn btn-link btn-block pb-0 bg-white d-flex justify-content text-left gray_dark_01 regular-14 weight-600 p-0"
												type="button"
												data-toggle="collapse"
												data-target="#tableCollapseOne"
												aria-expanded="true"
												aria-controls="tableCollapseOne"
											>
												<div className="arrow-down todo-arrow-down">
													<DownArrow />
												</div>
												<div classNamed-="ml-2">
													<p className="medium-14 blue">TO-DO</p>
												</div>
											</button>
										</h2>
									</div>
									<div
										id="tableCollapseOne"
										className="collapse show"
										aria-labelledby="headingOne"
										data-parent="#accordionExample"
									>
										<div className="card-body m- pt-0 border-0 bg-white">
											<div className="project-details-table">
												<table className="table todo-table with-border no-hover height-sm hover">
													<thead>
														<tr>
															<th colSpan={2}>Task</th>
															<th>Owner</th>
															<th>
																<div className="d-flex justify-content-center">
																	<p className="mr-3">Status</p>
																	<CommonImage src="/icons/info.svg" />
																</div>
															</th>
															<th>
																<div className="d-flex justify-content-center">
																	<p className="mr-3">Due Date</p>
																	<CommonImage src="/icons/info.svg" />
																</div>
															</th>
															<th>Priority</th>
															<th>Action</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td className="task-column">
																<p className="regular-14 gray_dark_01">
																	Task 1
																</p>
															</td>
															<td className="task-child-column">
																<CommonImage
																	className="cursor-pointer"
																	src="icons/comments-gray.svg"
																	width={24}
																	height={24}
																/>

																<CommonImage
																	className="profile-img"
																	src="/icons/add.svg"
																	width={24}
																	height={24}
																/>
															</td>
															<td className="owner-column">
																<div className="owner-img">
																	<CommonImage
																		className="cursor-pointer"
																		src="/images/pro_pic_default.svg"
																		width={24}
																		height={24}
																	/>
																	<CommonImage
																		className="profile-img"
																		src="/images/alave.png"
																		width={24}
																		height={24}
																	/>
																</div>
																<div className="select-component owner-box shadow-8dp">
																	<div className="dropdown-box dropdown-menu show">
																		<div className="m-0 search-filter">
																			<div className="with-icon right-icon">
																				<input
																					placeholder="Search"
																					type="text"
																				/>
																				<span className="right-icon">
																					<img src=" /icons/search.png" />
																				</span>
																			</div>
																		</div>
																		<div className="list-items scroll-y-label">
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage
																					className="cursor-pointer"
																					src="/images/pro_pic_default.svg"
																					width={24}
																					height={24}
																				/>
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage src="/icons/add-people.svg" />
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p className="regular-14 gray_dark_01">
																	status
																</p>
																<div className="select-tag-dropdown">
																	<div className="py-2 px-3">
																		<div className="selected-tags design-tags mb-2">
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				3D completed
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(223, 242, 255)'
																				}}
																			>
																				Shafie
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																		</div>
																		<div className="input-tag">
																			<input
																				type="text"
																				autoComplete="off"
																				placeholder="Select or create new"
																				value=""
																			/>
																			<CommonImage src="/images/chevron_down.svg" />
																		</div>
																	</div>

																	<div className="suggested-tags scroll-y-label mt-1">
																		<p className="px-3 py-1 d-flex align-items-center custom-suggested-tag">
																			<span
																				className="status radius cursor-pointer"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				Design completed
																			</span>
																		</p>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p>
																	<input type="date" name="" id="" />
																</p>
															</td>
															<td>Action 1</td>

															<td className="action-column">
																<div className="option">
																	<div className="dropdown">
																		<button
																			className="btn btn-default dropdown-toggle border-0"
																			type="button"
																			id="menu1"
																			data-toggle="dropdown"
																			aria-expanded="false"
																		>
																			<img
																				src="/icons/more_icon.svg"
																				alt=""
																			/>
																		</button>
																		<ul
																			className="dropdown-menu dropdown-menu-right shadow-lg"
																			role="menu"
																			aria-labelledby="menu1"
																			x-placement="bottom-end"
																		>
																			<li
																				role="presentation"
																				className="px-4 pb-3 pt-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href="/invoices/edit/10052"
																				>
																					Edit
																				</a>
																			</li>
																			<li
																				role="presentation"
																				className="px-4 pb-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href
																				>
																					Delete
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</td>
														</tr>
														<tr>
															<td className="task-column">
																<p className="regular-14 gray_dark_01">
																	Task 1
																</p>
															</td>
															<td className="task-child-column">
																<CommonImage
																	className="cursor-pointer"
																	src="icons/comments-gray.svg"
																	width={24}
																	height={24}
																/>

																<CommonImage
																	className="profile-img"
																	src="/icons/add.svg"
																	width={24}
																	height={24}
																/>
															</td>
															<td className="owner-column">
																<div className="owner-img">
																	<CommonImage
																		className="cursor-pointer"
																		src="/images/pro_pic_default.svg"
																		width={24}
																		height={24}
																	/>
																	<CommonImage
																		className="profile-img"
																		src="/images/alave.png"
																		width={24}
																		height={24}
																	/>
																</div>
																<div className="select-component owner-box shadow-8dp">
																	<div className="dropdown-box dropdown-menu show">
																		<div className="m-0 search-filter">
																			<div className="with-icon right-icon">
																				<input
																					placeholder="Search"
																					type="text"
																				/>
																				<span className="right-icon">
																					<img src=" /icons/search.png" />
																				</span>
																			</div>
																		</div>
																		<div className="list-items scroll-y-label">
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage
																					className="cursor-pointer"
																					src="/images/pro_pic_default.svg"
																					width={24}
																					height={24}
																				/>
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage src="/icons/add-people.svg" />
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p className="regular-14 gray_dark_01">
																	status
																</p>
																<div className="select-tag-dropdown">
																	<div className="py-2 px-3">
																		<div className="selected-tags design-tags mb-2">
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				3D completed
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(223, 242, 255)'
																				}}
																			>
																				Shafie
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																		</div>
																		<div className="input-tag">
																			<input
																				type="text"
																				autoComplete="off"
																				placeholder="Select or create new"
																				value=""
																			/>
																			<CommonImage src="/images/chevron_down.svg" />
																		</div>
																	</div>

																	<div className="suggested-tags scroll-y-label mt-1">
																		<p className="px-3 py-1 d-flex align-items-center custom-suggested-tag">
																			<span
																				className="status radius cursor-pointer"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				Design completed
																			</span>
																		</p>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p>
																	<input type="date" name="" id="" />
																</p>
															</td>
															<td>Action 1</td>

															<td className="action-column">
																<div className="option">
																	<div className="dropdown">
																		<button
																			className="btn btn-default dropdown-toggle border-0"
																			type="button"
																			id="menu1"
																			data-toggle="dropdown"
																			aria-expanded="false"
																		>
																			<img
																				src="/icons/more_icon.svg"
																				alt=""
																			/>
																		</button>
																		<ul
																			className="dropdown-menu dropdown-menu-right shadow-lg"
																			role="menu"
																			aria-labelledby="menu1"
																			x-placement="bottom-end"
																		>
																			<li
																				role="presentation"
																				className="px-4 pb-3 pt-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href="/invoices/edit/10052"
																				>
																					Edit
																				</a>
																			</li>
																			<li
																				role="presentation"
																				className="px-4 pb-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href
																				>
																					Delete
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</td>
														</tr>
														<tr>
															<td className="task-column">
																<p className="regular-14 gray_dark_01">
																	Task 1
																</p>
															</td>
															<td className="task-child-column">
																<CommonImage
																	className="cursor-pointer"
																	src="icons/comments-gray.svg"
																	width={24}
																	height={24}
																/>

																<CommonImage
																	className="profile-img"
																	src="/icons/add.svg"
																	width={24}
																	height={24}
																/>
															</td>
															<td className="owner-column">
																<div className="owner-img">
																	<CommonImage
																		className="cursor-pointer"
																		src="/images/pro_pic_default.svg"
																		width={24}
																		height={24}
																	/>
																	<CommonImage
																		className="profile-img"
																		src="/images/alave.png"
																		width={24}
																		height={24}
																	/>
																</div>
																<div className="select-component owner-box shadow-8dp">
																	<div className="dropdown-box dropdown-menu show">
																		<div className="m-0 search-filter">
																			<div className="with-icon right-icon">
																				<input
																					placeholder="Search"
																					type="text"
																				/>
																				<span className="right-icon">
																					<img src=" /icons/search.png" />
																				</span>
																			</div>
																		</div>
																		<div className="list-items scroll-y-label">
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage
																					className="cursor-pointer"
																					src="/images/pro_pic_default.svg"
																					width={24}
																					height={24}
																				/>
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage src="/icons/add-people.svg" />
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p className="regular-14 gray_dark_01">
																	status
																</p>
																<div className="select-tag-dropdown">
																	<div className="py-2 px-3">
																		<div className="selected-tags design-tags mb-2">
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				3D completed
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(223, 242, 255)'
																				}}
																			>
																				Shafie
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																		</div>
																		<div className="input-tag">
																			<input
																				type="text"
																				autoComplete="off"
																				placeholder="Select or create new"
																				value=""
																			/>
																			<CommonImage src="/images/chevron_down.svg" />
																		</div>
																	</div>

																	<div className="suggested-tags scroll-y-label mt-1">
																		<p className="px-3 py-1 d-flex align-items-center custom-suggested-tag">
																			<span
																				className="status radius cursor-pointer"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				Design completed
																			</span>
																		</p>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p>
																	<input type="date" name="" id="" />
																</p>
															</td>
															<td>Action 1</td>

															<td className="action-column">
																<div className="option">
																	<div className="dropdown">
																		<button
																			className="btn btn-default dropdown-toggle border-0"
																			type="button"
																			id="menu1"
																			data-toggle="dropdown"
																			aria-expanded="false"
																		>
																			<img
																				src="/icons/more_icon.svg"
																				alt=""
																			/>
																		</button>
																		<ul
																			className="dropdown-menu dropdown-menu-right shadow-lg"
																			role="menu"
																			aria-labelledby="menu1"
																			x-placement="bottom-end"
																		>
																			<li
																				role="presentation"
																				className="px-4 pb-3 pt-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href="/invoices/edit/10052"
																				>
																					Edit
																				</a>
																			</li>
																			<li
																				role="presentation"
																				className="px-4 pb-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href
																				>
																					Delete
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</td>
														</tr>
														<tr>
															<td className="task-column">
																<p className="regular-14 gray_dark_01">
																	Task 1
																</p>
															</td>
															<td className="task-child-column">
																<CommonImage
																	className="cursor-pointer"
																	src="icons/comments-gray.svg"
																	width={24}
																	height={24}
																/>

																<CommonImage
																	className="profile-img"
																	src="/icons/add.svg"
																	width={24}
																	height={24}
																/>
															</td>
															<td className="owner-column">
																<div className="owner-img">
																	<CommonImage
																		className="cursor-pointer"
																		src="/images/pro_pic_default.svg"
																		width={24}
																		height={24}
																	/>
																	<CommonImage
																		className="profile-img"
																		src="/images/alave.png"
																		width={24}
																		height={24}
																	/>
																</div>
																<div className="select-component owner-box shadow-8dp">
																	<div className="dropdown-box dropdown-menu show">
																		<div className="m-0 search-filter">
																			<div className="with-icon right-icon">
																				<input
																					placeholder="Search"
																					type="text"
																				/>
																				<span className="right-icon">
																					<img src=" /icons/search.png" />
																				</span>
																			</div>
																		</div>
																		<div className="list-items scroll-y-label">
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage
																					className="cursor-pointer"
																					src="/images/pro_pic_default.svg"
																					width={24}
																					height={24}
																				/>
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage src="/icons/add-people.svg" />
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p className="regular-14 gray_dark_01">
																	status
																</p>
																<div className="select-tag-dropdown">
																	<div className="py-2 px-3">
																		<div className="selected-tags design-tags mb-2">
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				3D completed
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(223, 242, 255)'
																				}}
																			>
																				Shafie
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																		</div>
																		<div className="input-tag">
																			<input
																				type="text"
																				autoComplete="off"
																				placeholder="Select or create new"
																				value=""
																			/>
																			<CommonImage src="/images/chevron_down.svg" />
																		</div>
																	</div>

																	<div className="suggested-tags scroll-y-label mt-1">
																		<p className="px-3 py-1 d-flex align-items-center custom-suggested-tag">
																			<span
																				className="status radius cursor-pointer"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				Design completed
																			</span>
																		</p>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p>
																	<input type="date" name="" id="" />
																</p>
															</td>
															<td>Action 1</td>

															<td className="action-column">
																<div className="option">
																	<div className="dropdown">
																		<button
																			className="btn btn-default dropdown-toggle border-0"
																			type="button"
																			id="menu1"
																			data-toggle="dropdown"
																			aria-expanded="false"
																		>
																			<img
																				src="/icons/more_icon.svg"
																				alt=""
																			/>
																		</button>
																		<ul
																			className="dropdown-menu dropdown-menu-right shadow-lg"
																			role="menu"
																			aria-labelledby="menu1"
																			x-placement="bottom-end"
																		>
																			<li
																				role="presentation"
																				className="px-4 pb-3 pt-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href="/invoices/edit/10052"
																				>
																					Edit
																				</a>
																			</li>
																			<li
																				role="presentation"
																				className="px-4 pb-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href
																				>
																					Delete
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</td>
														</tr>
														<tr>
															<td className="task-column">
																<p className="regular-14 gray_dark_01">
																	Task 1
																</p>
															</td>
															<td className="task-child-column">
																<CommonImage
																	className="cursor-pointer"
																	src="icons/comments-gray.svg"
																	width={24}
																	height={24}
																/>

																<CommonImage
																	className="profile-img"
																	src="/icons/add.svg"
																	width={24}
																	height={24}
																/>
															</td>
															<td className="owner-column">
																<div className="owner-img">
																	<CommonImage
																		className="cursor-pointer"
																		src="/images/pro_pic_default.svg"
																		width={24}
																		height={24}
																	/>
																	<CommonImage
																		className="profile-img"
																		src="/images/alave.png"
																		width={24}
																		height={24}
																	/>
																</div>
																<div className="select-component owner-box shadow-8dp">
																	<div className="dropdown-box dropdown-menu show">
																		<div className="m-0 search-filter">
																			<div className="with-icon right-icon">
																				<input
																					placeholder="Search"
																					type="text"
																				/>
																				<span className="right-icon">
																					<img src=" /icons/search.png" />
																				</span>
																			</div>
																		</div>
																		<div className="list-items scroll-y-label">
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage
																					className="cursor-pointer"
																					src="/images/pro_pic_default.svg"
																					width={24}
																					height={24}
																				/>
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage src="/icons/add-people.svg" />
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p className="regular-14 gray_dark_01">
																	status
																</p>
																<div className="select-tag-dropdown">
																	<div className="py-2 px-3">
																		<div className="selected-tags design-tags mb-2">
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				3D completed
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(223, 242, 255)'
																				}}
																			>
																				Shafie
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																		</div>
																		<div className="input-tag">
																			<input
																				type="text"
																				autoComplete="off"
																				placeholder="Select or create new"
																				value=""
																			/>
																			<CommonImage src="/images/chevron_down.svg" />
																		</div>
																	</div>

																	<div className="suggested-tags scroll-y-label mt-1">
																		<p className="px-3 py-1 d-flex align-items-center custom-suggested-tag">
																			<span
																				className="status radius cursor-pointer"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				Design completed
																			</span>
																		</p>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p>
																	<input type="date" name="" id="" />
																</p>
															</td>
															<td>Action 1</td>

															<td className="action-column">
																<div className="option">
																	<div className="dropdown">
																		<button
																			className="btn btn-default dropdown-toggle border-0"
																			type="button"
																			id="menu1"
																			data-toggle="dropdown"
																			aria-expanded="false"
																		>
																			<img
																				src="/icons/more_icon.svg"
																				alt=""
																			/>
																		</button>
																		<ul
																			className="dropdown-menu dropdown-menu-right shadow-lg"
																			role="menu"
																			aria-labelledby="menu1"
																			x-placement="bottom-end"
																		>
																			<li
																				role="presentation"
																				className="px-4 pb-3 pt-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href="/invoices/edit/10052"
																				>
																					Edit
																				</a>
																			</li>
																			<li
																				role="presentation"
																				className="px-4 pb-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href
																				>
																					Delete
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</td>
														</tr>
														<tr>
															<td className="task-column">
																<p className="regular-14 gray_dark_01">
																	Task 1
																</p>
															</td>
															<td className="task-child-column">
																<CommonImage
																	className="cursor-pointer"
																	src="icons/comments-gray.svg"
																	width={24}
																	height={24}
																/>

																<CommonImage
																	className="profile-img"
																	src="/icons/add.svg"
																	width={24}
																	height={24}
																/>
															</td>
															<td className="owner-column">
																<div className="owner-img">
																	<CommonImage
																		className="cursor-pointer"
																		src="/images/pro_pic_default.svg"
																		width={24}
																		height={24}
																	/>
																	<CommonImage
																		className="profile-img"
																		src="/images/alave.png"
																		width={24}
																		height={24}
																	/>
																</div>
																<div className="select-component owner-box shadow-8dp">
																	<div className="dropdown-box dropdown-menu show">
																		<div className="m-0 search-filter">
																			<div className="with-icon right-icon">
																				<input
																					placeholder="Search"
																					type="text"
																				/>
																				<span className="right-icon">
																					<img src=" /icons/search.png" />
																				</span>
																			</div>
																		</div>
																		<div className="list-items scroll-y-label">
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage
																					className="cursor-pointer"
																					src="/images/pro_pic_default.svg"
																					width={24}
																					height={24}
																				/>
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage src="/icons/add-people.svg" />
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p className="regular-14 gray_dark_01">
																	status
																</p>
																<div className="select-tag-dropdown">
																	<div className="py-2 px-3">
																		<div className="selected-tags design-tags mb-2">
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				3D completed
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(223, 242, 255)'
																				}}
																			>
																				Shafie
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																		</div>
																		<div className="input-tag">
																			<input
																				type="text"
																				autoComplete="off"
																				placeholder="Select or create new"
																				value=""
																			/>
																			<CommonImage src="/images/chevron_down.svg" />
																		</div>
																	</div>

																	<div className="suggested-tags scroll-y-label mt-1">
																		<p className="px-3 py-1 d-flex align-items-center custom-suggested-tag">
																			<span
																				className="status radius cursor-pointer"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				Design completed
																			</span>
																		</p>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p>
																	<input type="date" name="" id="" />
																</p>
															</td>
															<td>Action 1</td>

															<td className="action-column">
																<div className="option">
																	<div className="dropdown">
																		<button
																			className="btn btn-default dropdown-toggle border-0"
																			type="button"
																			id="menu1"
																			data-toggle="dropdown"
																			aria-expanded="false"
																		>
																			<img
																				src="/icons/more_icon.svg"
																				alt=""
																			/>
																		</button>
																		<ul
																			className="dropdown-menu dropdown-menu-right shadow-lg"
																			role="menu"
																			aria-labelledby="menu1"
																			x-placement="bottom-end"
																		>
																			<li
																				role="presentation"
																				className="px-4 pb-3 pt-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href="/invoices/edit/10052"
																				>
																					Edit
																				</a>
																			</li>
																			<li
																				role="presentation"
																				className="px-4 pb-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href
																				>
																					Delete
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</td>
														</tr>

														<tr>
															<td className="task-column">
																<p className="regular-14 gray_dark_01">
																	Task 1
																</p>
															</td>
															<td className="task-child-column">
																<CommonImage
																	className="cursor-pointer"
																	src="icons/comments-gray.svg"
																	width={24}
																	height={24}
																/>

																<CommonImage
																	className="profile-img"
																	src="/icons/add.svg"
																	width={24}
																	height={24}
																/>
															</td>
															<td className="owner-column">
																<div className="owner-img">
																	<CommonImage
																		className="cursor-pointer"
																		src="/images/pro_pic_default.svg"
																		width={24}
																		height={24}
																	/>
																	<CommonImage
																		className="profile-img"
																		src="/images/alave.png"
																		width={24}
																		height={24}
																	/>
																</div>
																<div className="select-component owner-box shadow-8dp">
																	<div className="dropdown-box dropdown-menu show">
																		<div className="m-0 search-filter">
																			<div className="with-icon right-icon">
																				<input
																					placeholder="Search"
																					type="text"
																				/>
																				<span className="right-icon">
																					<img src=" /icons/search.png" />
																				</span>
																			</div>
																		</div>
																		<div className="list-items scroll-y-label">
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage
																					className="cursor-pointer"
																					src="/images/pro_pic_default.svg"
																					width={24}
																					height={24}
																				/>
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage src="/icons/add-people.svg" />
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p className="regular-14 gray_dark_01">
																	status
																</p>
																<div className="select-tag-dropdown">
																	<div className="py-2 px-3">
																		<div className="selected-tags design-tags mb-2">
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				3D completed
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(223, 242, 255)'
																				}}
																			>
																				Shafie
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																		</div>
																		<div className="input-tag">
																			<input
																				type="text"
																				autoComplete="off"
																				placeholder="Select or create new"
																				value=""
																			/>
																			<CommonImage src="/images/chevron_down.svg" />
																		</div>
																	</div>

																	<div className="suggested-tags scroll-y-label mt-1">
																		<p className="px-3 py-1 d-flex align-items-center custom-suggested-tag">
																			<span
																				className="status radius cursor-pointer"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				Design completed
																			</span>
																		</p>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p>
																	<input type="date" name="" id="" />
																</p>
															</td>
															<td>Action 1</td>

															<td className="action-column">
																<div className="option">
																	<div className="dropdown">
																		<button
																			className="btn btn-default dropdown-toggle border-0"
																			type="button"
																			id="menu1"
																			data-toggle="dropdown"
																			aria-expanded="false"
																		>
																			<img
																				src="/icons/more_icon.svg"
																				alt=""
																			/>
																		</button>
																		<ul
																			className="dropdown-menu dropdown-menu-right shadow-lg"
																			role="menu"
																			aria-labelledby="menu1"
																			x-placement="bottom-end"
																		>
																			<li
																				role="presentation"
																				className="px-4 pb-3 pt-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href="/invoices/edit/10052"
																				>
																					Edit
																				</a>
																			</li>
																			<li
																				role="presentation"
																				className="px-4 pb-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href
																				>
																					Delete
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="accordion border-0" id="accordionExample">
								<div className="card mb-0">
									<div className="card-header" id="headingOne">
										<h2 className="mb-0">
											<button
												className="btn btn-link btn-block pb-0 bg-white d-flex justify-content text-left gray_dark_01 regular-14 weight-600 p-0"
												type="button"
												data-toggle="collapse"
												data-target="#tableCollapseOne"
												aria-expanded="true"
												aria-controls="tableCollapseOne"
											>
												<div className="arrow-down completed-arrow-down">
													<DownArrow />
												</div>
												<div classNamed-="ml-2">
													<p className="medium-14 green">TO-DO</p>
												</div>
											</button>
										</h2>
									</div>
									<div
										id="tableCollapseOne"
										className="collapse show"
										aria-labelledby="headingOne"
										data-parent="#accordionExample"
									>
										<div className="card-body m- pt-0 border-0 bg-white">
											<div className="project-details-table">
												<table className="table todo-table completed-table with-border no-hover height-sm hover">
													<thead>
														<tr>
															<th colSpan={2}>Task</th>
															<th>Owner</th>
															<th>
																<div className="d-flex justify-content-center">
																	<p className="mr-3">Status</p>
																	<CommonImage src="/icons/info.svg" />
																</div>
															</th>
															<th>
																<div className="d-flex justify-content-center">
																	<p className="mr-3">Due Date</p>
																	<CommonImage src="/icons/info.svg" />
																</div>
															</th>
															<th>Priority</th>
															<th>Action</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td className="task-column">
																<p className="regular-14 gray_dark_01">
																	Task 1
																</p>
															</td>
															<td className="task-child-column">
																<CommonImage
																	className="cursor-pointer"
																	src="icons/comments-gray.svg"
																	width={24}
																	height={24}
																/>

																<CommonImage
																	className="profile-img"
																	src="/icons/add.svg"
																	width={24}
																	height={24}
																/>
															</td>
															<td className="owner-column">
																<div className="owner-img">
																	<CommonImage
																		className="cursor-pointer"
																		src="/images/pro_pic_default.svg"
																		width={24}
																		height={24}
																	/>
																	<CommonImage
																		className="profile-img"
																		src="/images/alave.png"
																		width={24}
																		height={24}
																	/>
																</div>
																<div className="select-component owner-box shadow-8dp">
																	<div className="dropdown-box dropdown-menu show">
																		<div className="m-0 search-filter">
																			<div className="with-icon right-icon">
																				<input
																					placeholder="Search"
																					type="text"
																				/>
																				<span className="right-icon">
																					<img src=" /icons/search.png" />
																				</span>
																			</div>
																		</div>
																		<div className="list-items scroll-y-label">
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage
																					className="cursor-pointer"
																					src="/images/pro_pic_default.svg"
																					width={24}
																					height={24}
																				/>
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage src="/icons/add-people.svg" />
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p className="regular-14 gray_dark_01">
																	status
																</p>
																<div className="select-tag-dropdown">
																	<div className="py-2 px-3">
																		<div className="selected-tags design-tags mb-2">
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				3D completed
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(223, 242, 255)'
																				}}
																			>
																				Shafie
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																		</div>
																		<div className="input-tag">
																			<input
																				type="text"
																				autoComplete="off"
																				placeholder="Select or create new"
																				value=""
																			/>
																			<CommonImage src="/images/chevron_down.svg" />
																		</div>
																	</div>

																	<div className="suggested-tags scroll-y-label mt-1">
																		<p className="px-3 py-1 d-flex align-items-center custom-suggested-tag">
																			<span
																				className="status radius cursor-pointer"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				Design completed
																			</span>
																		</p>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p>
																	<input type="date" name="" id="" />
																</p>
															</td>
															<td>Action 1</td>

															<td className="action-column">
																<div className="option">
																	<div className="dropdown">
																		<button
																			className="btn btn-default dropdown-toggle border-0"
																			type="button"
																			id="menu1"
																			data-toggle="dropdown"
																			aria-expanded="false"
																		>
																			<img
																				src="/icons/more_icon.svg"
																				alt=""
																			/>
																		</button>
																		<ul
																			className="dropdown-menu dropdown-menu-right shadow-lg"
																			role="menu"
																			aria-labelledby="menu1"
																			x-placement="bottom-end"
																		>
																			<li
																				role="presentation"
																				className="px-4 pb-3 pt-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href="/invoices/edit/10052"
																				>
																					Edit
																				</a>
																			</li>
																			<li
																				role="presentation"
																				className="px-4 pb-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href
																				>
																					Delete
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</td>
														</tr>
														<tr>
															<td className="task-column">
																<p className="regular-14 gray_dark_01">
																	Task 1
																</p>
															</td>
															<td className="task-child-column">
																<CommonImage
																	className="cursor-pointer"
																	src="icons/comments-gray.svg"
																	width={24}
																	height={24}
																/>

																<CommonImage
																	className="profile-img"
																	src="/icons/add.svg"
																	width={24}
																	height={24}
																/>
															</td>
															<td className="owner-column">
																<div className="owner-img">
																	<CommonImage
																		className="cursor-pointer"
																		src="/images/pro_pic_default.svg"
																		width={24}
																		height={24}
																	/>
																	<CommonImage
																		className="profile-img"
																		src="/images/alave.png"
																		width={24}
																		height={24}
																	/>
																</div>
																<div className="select-component owner-box shadow-8dp">
																	<div className="dropdown-box dropdown-menu show">
																		<div className="m-0 search-filter">
																			<div className="with-icon right-icon">
																				<input
																					placeholder="Search"
																					type="text"
																				/>
																				<span className="right-icon">
																					<img src=" /icons/search.png" />
																				</span>
																			</div>
																		</div>
																		<div className="list-items scroll-y-label">
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage
																					className="cursor-pointer"
																					src="/images/pro_pic_default.svg"
																					width={24}
																					height={24}
																				/>
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage src="/icons/add-people.svg" />
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p className="regular-14 gray_dark_01">
																	status
																</p>
																<div className="select-tag-dropdown">
																	<div className="py-2 px-3">
																		<div className="selected-tags design-tags mb-2">
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				3D completed
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(223, 242, 255)'
																				}}
																			>
																				Shafie
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																		</div>
																		<div className="input-tag">
																			<input
																				type="text"
																				autoComplete="off"
																				placeholder="Select or create new"
																				value=""
																			/>
																			<CommonImage src="/images/chevron_down.svg" />
																		</div>
																	</div>

																	<div className="suggested-tags scroll-y-label mt-1">
																		<p className="px-3 py-1 d-flex align-items-center custom-suggested-tag">
																			<span
																				className="status radius cursor-pointer"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				Design completed
																			</span>
																		</p>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p>
																	<input type="date" name="" id="" />
																</p>
															</td>
															<td>Action 1</td>

															<td className="action-column">
																<div className="option">
																	<div className="dropdown">
																		<button
																			className="btn btn-default dropdown-toggle border-0"
																			type="button"
																			id="menu1"
																			data-toggle="dropdown"
																			aria-expanded="false"
																		>
																			<img
																				src="/icons/more_icon.svg"
																				alt=""
																			/>
																		</button>
																		<ul
																			className="dropdown-menu dropdown-menu-right shadow-lg"
																			role="menu"
																			aria-labelledby="menu1"
																			x-placement="bottom-end"
																		>
																			<li
																				role="presentation"
																				className="px-4 pb-3 pt-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href="/invoices/edit/10052"
																				>
																					Edit
																				</a>
																			</li>
																			<li
																				role="presentation"
																				className="px-4 pb-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href
																				>
																					Delete
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</td>
														</tr>
														<tr>
															<td className="task-column">
																<p className="regular-14 gray_dark_01">
																	Task 1
																</p>
															</td>
															<td className="task-child-column">
																<CommonImage
																	className="cursor-pointer"
																	src="icons/comments-gray.svg"
																	width={24}
																	height={24}
																/>

																<CommonImage
																	className="profile-img"
																	src="/icons/add.svg"
																	width={24}
																	height={24}
																/>
															</td>
															<td className="owner-column">
																<div className="owner-img">
																	<CommonImage
																		className="cursor-pointer"
																		src="/images/pro_pic_default.svg"
																		width={24}
																		height={24}
																	/>
																	<CommonImage
																		className="profile-img"
																		src="/images/alave.png"
																		width={24}
																		height={24}
																	/>
																</div>
																<div className="select-component owner-box shadow-8dp">
																	<div className="dropdown-box dropdown-menu show">
																		<div className="m-0 search-filter">
																			<div className="with-icon right-icon">
																				<input
																					placeholder="Search"
																					type="text"
																				/>
																				<span className="right-icon">
																					<img src=" /icons/search.png" />
																				</span>
																			</div>
																		</div>
																		<div className="list-items scroll-y-label">
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage
																					className="cursor-pointer"
																					src="/images/pro_pic_default.svg"
																					width={24}
																					height={24}
																				/>
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage src="/icons/add-people.svg" />
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p className="regular-14 gray_dark_01">
																	status
																</p>
																<div className="select-tag-dropdown">
																	<div className="py-2 px-3">
																		<div className="selected-tags design-tags mb-2">
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				3D completed
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(223, 242, 255)'
																				}}
																			>
																				Shafie
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																		</div>
																		<div className="input-tag">
																			<input
																				type="text"
																				autoComplete="off"
																				placeholder="Select or create new"
																				value=""
																			/>
																			<CommonImage src="/images/chevron_down.svg" />
																		</div>
																	</div>

																	<div className="suggested-tags scroll-y-label mt-1">
																		<p className="px-3 py-1 d-flex align-items-center custom-suggested-tag">
																			<span
																				className="status radius cursor-pointer"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				Design completed
																			</span>
																		</p>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p>
																	<input type="date" name="" id="" />
																</p>
															</td>
															<td>Action 1</td>

															<td className="action-column">
																<div className="option">
																	<div className="dropdown">
																		<button
																			className="btn btn-default dropdown-toggle border-0"
																			type="button"
																			id="menu1"
																			data-toggle="dropdown"
																			aria-expanded="false"
																		>
																			<img
																				src="/icons/more_icon.svg"
																				alt=""
																			/>
																		</button>
																		<ul
																			className="dropdown-menu dropdown-menu-right shadow-lg"
																			role="menu"
																			aria-labelledby="menu1"
																			x-placement="bottom-end"
																		>
																			<li
																				role="presentation"
																				className="px-4 pb-3 pt-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href="/invoices/edit/10052"
																				>
																					Edit
																				</a>
																			</li>
																			<li
																				role="presentation"
																				className="px-4 pb-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href
																				>
																					Delete
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</td>
														</tr>
														<tr>
															<td className="task-column">
																<p className="regular-14 gray_dark_01">
																	Task 1
																</p>
															</td>
															<td className="task-child-column">
																<CommonImage
																	className="cursor-pointer"
																	src="icons/comments-gray.svg"
																	width={24}
																	height={24}
																/>

																<CommonImage
																	className="profile-img"
																	src="/icons/add.svg"
																	width={24}
																	height={24}
																/>
															</td>
															<td className="owner-column">
																<div className="owner-img">
																	<CommonImage
																		className="cursor-pointer"
																		src="/images/pro_pic_default.svg"
																		width={24}
																		height={24}
																	/>
																	<CommonImage
																		className="profile-img"
																		src="/images/alave.png"
																		width={24}
																		height={24}
																	/>
																</div>
																<div className="select-component owner-box shadow-8dp">
																	<div className="dropdown-box dropdown-menu show">
																		<div className="m-0 search-filter">
																			<div className="with-icon right-icon">
																				<input
																					placeholder="Search"
																					type="text"
																				/>
																				<span className="right-icon">
																					<img src=" /icons/search.png" />
																				</span>
																			</div>
																		</div>
																		<div className="list-items scroll-y-label">
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage
																					className="cursor-pointer"
																					src="/images/pro_pic_default.svg"
																					width={24}
																					height={24}
																				/>
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage src="/icons/add-people.svg" />
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p className="regular-14 gray_dark_01">
																	status
																</p>
																<div className="select-tag-dropdown">
																	<div className="py-2 px-3">
																		<div className="selected-tags design-tags mb-2">
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				3D completed
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(223, 242, 255)'
																				}}
																			>
																				Shafie
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																		</div>
																		<div className="input-tag">
																			<input
																				type="text"
																				autoComplete="off"
																				placeholder="Select or create new"
																				value=""
																			/>
																			<CommonImage src="/images/chevron_down.svg" />
																		</div>
																	</div>

																	<div className="suggested-tags scroll-y-label mt-1">
																		<p className="px-3 py-1 d-flex align-items-center custom-suggested-tag">
																			<span
																				className="status radius cursor-pointer"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				Design completed
																			</span>
																		</p>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p>
																	<input type="date" name="" id="" />
																</p>
															</td>
															<td>Action 1</td>

															<td className="action-column">
																<div className="option">
																	<div className="dropdown">
																		<button
																			className="btn btn-default dropdown-toggle border-0"
																			type="button"
																			id="menu1"
																			data-toggle="dropdown"
																			aria-expanded="false"
																		>
																			<img
																				src="/icons/more_icon.svg"
																				alt=""
																			/>
																		</button>
																		<ul
																			className="dropdown-menu dropdown-menu-right shadow-lg"
																			role="menu"
																			aria-labelledby="menu1"
																			x-placement="bottom-end"
																		>
																			<li
																				role="presentation"
																				className="px-4 pb-3 pt-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href="/invoices/edit/10052"
																				>
																					Edit
																				</a>
																			</li>
																			<li
																				role="presentation"
																				className="px-4 pb-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href
																				>
																					Delete
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</td>
														</tr>
														<tr>
															<td className="task-column">
																<p className="regular-14 gray_dark_01">
																	Task 1
																</p>
															</td>
															<td className="task-child-column">
																<CommonImage
																	className="cursor-pointer"
																	src="icons/comments-gray.svg"
																	width={24}
																	height={24}
																/>

																<CommonImage
																	className="profile-img"
																	src="/icons/add.svg"
																	width={24}
																	height={24}
																/>
															</td>
															<td className="owner-column">
																<div className="owner-img">
																	<CommonImage
																		className="cursor-pointer"
																		src="/images/pro_pic_default.svg"
																		width={24}
																		height={24}
																	/>
																	<CommonImage
																		className="profile-img"
																		src="/images/alave.png"
																		width={24}
																		height={24}
																	/>
																</div>
																<div className="select-component owner-box shadow-8dp">
																	<div className="dropdown-box dropdown-menu show">
																		<div className="m-0 search-filter">
																			<div className="with-icon right-icon">
																				<input
																					placeholder="Search"
																					type="text"
																				/>
																				<span className="right-icon">
																					<img src=" /icons/search.png" />
																				</span>
																			</div>
																		</div>
																		<div className="list-items scroll-y-label">
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage
																					className="cursor-pointer"
																					src="/images/pro_pic_default.svg"
																					width={24}
																					height={24}
																				/>
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage src="/icons/add-people.svg" />
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p className="regular-14 gray_dark_01">
																	status
																</p>
																<div className="select-tag-dropdown">
																	<div className="py-2 px-3">
																		<div className="selected-tags design-tags mb-2">
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				3D completed
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(223, 242, 255)'
																				}}
																			>
																				Shafie
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																		</div>
																		<div className="input-tag">
																			<input
																				type="text"
																				autoComplete="off"
																				placeholder="Select or create new"
																				value=""
																			/>
																			<CommonImage src="/images/chevron_down.svg" />
																		</div>
																	</div>

																	<div className="suggested-tags scroll-y-label mt-1">
																		<p className="px-3 py-1 d-flex align-items-center custom-suggested-tag">
																			<span
																				className="status radius cursor-pointer"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				Design completed
																			</span>
																		</p>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p>
																	<input type="date" name="" id="" />
																</p>
															</td>
															<td>Action 1</td>

															<td className="action-column">
																<div className="option">
																	<div className="dropdown">
																		<button
																			className="btn btn-default dropdown-toggle border-0"
																			type="button"
																			id="menu1"
																			data-toggle="dropdown"
																			aria-expanded="false"
																		>
																			<img
																				src="/icons/more_icon.svg"
																				alt=""
																			/>
																		</button>
																		<ul
																			className="dropdown-menu dropdown-menu-right shadow-lg"
																			role="menu"
																			aria-labelledby="menu1"
																			x-placement="bottom-end"
																		>
																			<li
																				role="presentation"
																				className="px-4 pb-3 pt-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href="/invoices/edit/10052"
																				>
																					Edit
																				</a>
																			</li>
																			<li
																				role="presentation"
																				className="px-4 pb-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href
																				>
																					Delete
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</td>
														</tr>
														<tr>
															<td className="task-column">
																<p className="regular-14 gray_dark_01">
																	Task 1
																</p>
															</td>
															<td className="task-child-column">
																<CommonImage
																	className="cursor-pointer"
																	src="icons/comments-gray.svg"
																	width={24}
																	height={24}
																/>

																<CommonImage
																	className="profile-img"
																	src="/icons/add.svg"
																	width={24}
																	height={24}
																/>
															</td>
															<td className="owner-column">
																<div className="owner-img">
																	<CommonImage
																		className="cursor-pointer"
																		src="/images/pro_pic_default.svg"
																		width={24}
																		height={24}
																	/>
																	<CommonImage
																		className="profile-img"
																		src="/images/alave.png"
																		width={24}
																		height={24}
																	/>
																</div>
																<div className="select-component owner-box shadow-8dp">
																	<div className="dropdown-box dropdown-menu show">
																		<div className="m-0 search-filter">
																			<div className="with-icon right-icon">
																				<input
																					placeholder="Search"
																					type="text"
																				/>
																				<span className="right-icon">
																					<img src=" /icons/search.png" />
																				</span>
																			</div>
																		</div>
																		<div className="list-items scroll-y-label">
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage
																					className="cursor-pointer"
																					src="/images/pro_pic_default.svg"
																					width={24}
																					height={24}
																				/>
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage src="/icons/add-people.svg" />
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p className="regular-14 gray_dark_01">
																	status
																</p>
																<div className="select-tag-dropdown">
																	<div className="py-2 px-3">
																		<div className="selected-tags design-tags mb-2">
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				3D completed
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(223, 242, 255)'
																				}}
																			>
																				Shafie
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																		</div>
																		<div className="input-tag">
																			<input
																				type="text"
																				autoComplete="off"
																				placeholder="Select or create new"
																				value=""
																			/>
																			<CommonImage src="/images/chevron_down.svg" />
																		</div>
																	</div>

																	<div className="suggested-tags scroll-y-label mt-1">
																		<p className="px-3 py-1 d-flex align-items-center custom-suggested-tag">
																			<span
																				className="status radius cursor-pointer"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				Design completed
																			</span>
																		</p>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p>
																	<input type="date" name="" id="" />
																</p>
															</td>
															<td>Action 1</td>

															<td className="action-column">
																<div className="option">
																	<div className="dropdown">
																		<button
																			className="btn btn-default dropdown-toggle border-0"
																			type="button"
																			id="menu1"
																			data-toggle="dropdown"
																			aria-expanded="false"
																		>
																			<img
																				src="/icons/more_icon.svg"
																				alt=""
																			/>
																		</button>
																		<ul
																			className="dropdown-menu dropdown-menu-right shadow-lg"
																			role="menu"
																			aria-labelledby="menu1"
																			x-placement="bottom-end"
																		>
																			<li
																				role="presentation"
																				className="px-4 pb-3 pt-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href="/invoices/edit/10052"
																				>
																					Edit
																				</a>
																			</li>
																			<li
																				role="presentation"
																				className="px-4 pb-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href
																				>
																					Delete
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</td>
														</tr>

														<tr>
															<td className="task-column">
																<p className="regular-14 gray_dark_01">
																	Task 1
																</p>
															</td>
															<td className="task-child-column">
																<CommonImage
																	className="cursor-pointer"
																	src="icons/comments-gray.svg"
																	width={24}
																	height={24}
																/>

																<CommonImage
																	className="profile-img"
																	src="/icons/add.svg"
																	width={24}
																	height={24}
																/>
															</td>
															<td className="owner-column">
																<div className="owner-img">
																	<CommonImage
																		className="cursor-pointer"
																		src="/images/pro_pic_default.svg"
																		width={24}
																		height={24}
																	/>
																	<CommonImage
																		className="profile-img"
																		src="/images/alave.png"
																		width={24}
																		height={24}
																	/>
																</div>
																<div className="select-component owner-box shadow-8dp">
																	<div className="dropdown-box dropdown-menu show">
																		<div className="m-0 search-filter">
																			<div className="with-icon right-icon">
																				<input
																					placeholder="Search"
																					type="text"
																				/>
																				<span className="right-icon">
																					<img src=" /icons/search.png" />
																				</span>
																			</div>
																		</div>
																		<div className="list-items scroll-y-label">
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage
																					className="cursor-pointer"
																					src="/images/pro_pic_default.svg"
																					width={24}
																					height={24}
																				/>
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																			<div className="single-item d-flex align-items-center py-2 px-3">
																				<CommonImage src="/icons/add-people.svg" />
																				<span className="regular-14 gray_dark_02 pl-2">
																					John Doe
																				</span>
																			</div>
																		</div>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p className="regular-14 gray_dark_01">
																	status
																</p>
																<div className="select-tag-dropdown">
																	<div className="py-2 px-3">
																		<div className="selected-tags design-tags mb-2">
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				3D completed
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																			<span
																				className="status radius"
																				style={{
																					background:
																						'rgb(223, 242, 255)'
																				}}
																			>
																				Shafie
																				<CommonImage src="/icons/chip-close.svg" />
																			</span>
																		</div>
																		<div className="input-tag">
																			<input
																				type="text"
																				autoComplete="off"
																				placeholder="Select or create new"
																				value=""
																			/>
																			<CommonImage src="/images/chevron_down.svg" />
																		</div>
																	</div>

																	<div className="suggested-tags scroll-y-label mt-1">
																		<p className="px-3 py-1 d-flex align-items-center custom-suggested-tag">
																			<span
																				className="status radius cursor-pointer"
																				style={{
																					background:
																						'rgb(251, 217, 194)'
																				}}
																			>
																				Design completed
																			</span>
																		</p>
																	</div>
																</div>
															</td>
															<td className="due-date-column">
																<p>
																	<input type="date" name="" id="" />
																</p>
															</td>
															<td>Action 1</td>

															<td className="action-column">
																<div className="option">
																	<div className="dropdown">
																		<button
																			className="btn btn-default dropdown-toggle border-0"
																			type="button"
																			id="menu1"
																			data-toggle="dropdown"
																			aria-expanded="false"
																		>
																			<img
																				src="/icons/more_icon.svg"
																				alt=""
																			/>
																		</button>
																		<ul
																			className="dropdown-menu dropdown-menu-right shadow-lg"
																			role="menu"
																			aria-labelledby="menu1"
																			x-placement="bottom-end"
																		>
																			<li
																				role="presentation"
																				className="px-4 pb-3 pt-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href="/invoices/edit/10052"
																				>
																					Edit
																				</a>
																			</li>
																			<li
																				role="presentation"
																				className="px-4 pb-3"
																			>
																				<a
																					role="menuitem"
																					tabIndex={-1}
																					className="font-weight-normal  text-black"
																					href
																				>
																					Delete
																				</a>
																			</li>
																		</ul>
																	</div>
																</div>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="add-new-button">
							<button className="button outline">
								<svg
									fill="none"
									height="24"
									viewBox="0 0 24 24"
									width="24"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
										fill="white"
									></path>
								</svg>
								<span className="ml-1">Button</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TaskDetails;
